import { Link } from "react-router-dom";
import { PageHeader, Loading, ErrorState, Empty, Status } from "../components/Layout";
import { useResource } from "../lib/api";

export default function Rights() {
  const pr = useResource("/projects");
  const pubs = useResource("/publications/mine");
  const cases = useResource("/cases");
  return (
    <div>
      <PageHeader title="Rights" sub="Each action — private processing, AI transmission, export and publication — is decided separately. A paid plan never overrides a rights denial." actions={<Link to="/help" className="btn btn-ghost btn-sm">Report or appeal</Link>} />
      <div className="grid lg:grid-cols-2 gap-5">
        <section className="card p-5"><h2 className="font-semibold mb-3">Project declarations</h2>
          {pr.loading ? <Loading /> : pr.error ? <ErrorState error={pr.error} onRetry={pr.reload} /> : pr.data.length === 0 ? <Empty title="No projects" /> :
            <div className="space-y-2">{pr.data.map((p) => <RightsRow key={p.id} p={p} />)}</div>}
        </section>
        <section className="space-y-5">
          <div className="card p-5"><h2 className="font-semibold mb-3">Publication requests</h2>
            {pubs.loading ? <Loading /> : !pubs.data?.length ? <p className="muted text-sm">None.</p> : pubs.data.map((x) => <div key={x.id} className="flex justify-between text-sm py-1"><span>{x.title} · {x.visibility}</span><Status value={x.status} /></div>)}</div>
          <div className="card p-5"><h2 className="font-semibold mb-3">Your cases</h2>
            {cases.loading ? <Loading /> : !cases.data?.length ? <p className="muted text-sm">None.</p> : cases.data.map((x) => <div key={x.id} className="flex justify-between text-sm py-1"><span>{x.type.replace("_", " ")} · {x.subject}</span><Status value={x.status} /></div>)}</div>
        </section>
      </div>
    </div>
  );
}

function RightsRow({ p }) {
  const d = useResource(`/projects/${p.id}`);
  return (
    <Link to={`/studio/${p.id}`} className="card-2 p-3 block hover:border-[var(--cyan)]" data-testid={`rights-row-${p.id}`}>
      <div className="flex justify-between text-sm font-medium"><span>{p.title}</span>{d.data?.rights ? <Status value={d.data.rights.status} /> : <Status value="not_started" />}</div>
      {d.data?.policy && <div className="flex flex-wrap gap-1 mt-2">{Object.entries(d.data.policy).map(([a, r]) => <span key={a} className="text-[10px] flex gap-1 items-center">{a.replace(/_/g, " ")}<Status value={r.decision} /></span>)}</div>}
    </Link>
  );
}
